export var DailyAggregationRowKind;
(function (DailyAggregationRowKind) {
    DailyAggregationRowKind["GROUP"] = "GROUP";
    DailyAggregationRowKind["RESERVATION"] = "RESERVATION";
})(DailyAggregationRowKind || (DailyAggregationRowKind = {}));
export var DailyCrmV3GroupType;
(function (DailyCrmV3GroupType) {
    DailyCrmV3GroupType["RESERVATION_GROUP"] = "RESERVATION_GROUP";
    DailyCrmV3GroupType["TRAVEL_BOOKING"] = "TRAVEL_BOOKING";
})(DailyCrmV3GroupType || (DailyCrmV3GroupType = {}));
